import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import DoneIcon from '@material-ui/icons/Done';

import { useStyles } from './styles';

const Chips = ({ color, variant, fullWidth, label, multiple, value, updateValue, chips, disabled }) => {
	const classes = useStyles({
		color,
		variant,
		fullWidth,
		numberOfChips: value.length
	});

	const handleSelect = selectedValue => {
		updateValue(selectedValue);
	};

	const handleSelectMultiple = selectedValue => {
		const currentIndex = value.indexOf(selectedValue);
		const newValue = [...value];

		if (currentIndex === -1) {
			newValue.push(selectedValue);
		} else {
			newValue.splice(currentIndex, 1);
		}

		updateValue(newValue);
	};

	return (
		<FormControl component="fieldset">
			{label && (
				<FormLabel component="legend" className={classes.formLabel}>
					<Typography variant="body2" color="textPrimary">
						{label}
					</Typography>
				</FormLabel>
			)}

			<FormGroup className={classes.formGroup}>
				{chips.map((chip, index) => {
					const chipValue = chip.value;
					const chipSelected = multiple ? value.indexOf(chipValue) !== -1 : value === chipValue;

					return (
						<Chip
							key={chipValue + '-' + index + '-chip'}
							variant={variant}
							avatar={multiple && chipSelected && <DoneIcon />}
							label={chip.label}
							disabled={disabled}
							onClick={() => (multiple ? handleSelectMultiple(chipValue) : handleSelect(chipValue))}
							className={clsx(
								classes.chip,
								{
									[classes.selectedChip]: chipSelected
								},
								{
									[classes.selectedChipMultiple]: multiple && chipSelected
								}
							)}
						/>
					);
				})}
			</FormGroup>
		</FormControl>
	);
};

Chips.propTypes = {
	color: PropTypes.oneOf(['primary', 'secondary']),
	variant: PropTypes.oneOf(['default', 'outlined']),
	fullWidth: PropTypes.bool,
	label: PropTypes.string,
	multiple: PropTypes.bool,
	value: PropTypes.oneOf([PropTypes.arrayOf(PropTypes.string), PropTypes.string]).isRequired,
	onChange: PropTypes.func.isRequired,
	chipValues: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired
		})
	).isRequired,
	disabled: PropTypes.bool
};

export default Chips;
